import R from 'ramda';
import { validateObject, validateField } from 'common/validation';

const contactInfoConstraints = {
  firstName: {
    presence: {
      message: "^First name can't be blank",
    },
  },
  lastName: {
    presence: {
      message: "^Last name can't be blank",
    },
  },
  orcidId: {
    presence: false,
    format: {
      pattern: /^$|^([0-9a-zA-Z]{4})-([0-9a-zA-Z]{4})-([0-9a-zA-Z]{4})-([0-9a-zA-Z]{4})$/,
      message: '^Invalid ORCID',
    },
  },
  email: {
    presence: {
      message: '^An email address is required',
    },
    email: {
      message: '^Please enter a valid email address',
    },
  },
  phoneNumber: {
    format: {
      pattern: /^([+ \-0-9()]){0,25}$/,
      message: '^Invalid phone number',
    },
  },
  'permanentAddress.addressLineOne': {
    presence: {
      message: '^A street address is required',
    },
  },
  'permanentAddress.locality': {
    presence: {
      message: '^A city is required',
    },
  },
  'permanentAddress.administrativeArea.code': {
    presence: {
      message: '^State/Province is required',
    },
  },
  'permanentAddress.country.code': {
    presence: {
      message: '^Please choose a country',
    },
  },
  'permanentAddress.postalCode': {
    presence: {
      message:
        '^A postal code is required, enter NA if your country does not use postal or zip codes',
    },
  },
};

export const validateContactInfoField = (field, value, errors = {}) =>
  validateField(contactInfoConstraints, field, value, errors);

export const validateContactInfo = R.partial(validateObject, [
  contactInfoConstraints,
]);



// WEBPACK FOOTER //
// ./src/contact-info/contactInfoValidation.js